import { Component, HostListener, Input, OnInit } from '@angular/core';
import { HideNavScrollService } from '../../services/hide-nav-scroll.service';
import { NavmenuService, Menu } from '../../services/navmenu.service';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification/notification.component';
import { ProfileComponent } from './profile/profile.component';
import { SearchComponent } from './search/search.component';
import { ThemeComponent } from './theme/theme.component';
import { ClickOutsideDirective } from '../../directives/outside.directive';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { TourService } from '../../../tour.service';
import { ThemeEventService } from '../../services/theme-event.service';
import { ConnectionService } from '../../../connection.service';
import { ToastService } from '../../services/toast.service';
import { ChangePasswordComponent } from '../../../auth/change-password/change-password.component';
import { filter } from 'rxjs';
import { LayoutService } from '../../services/layout.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-header',
  imports: [CommonModule,
    NotificationComponent,
    ProfileComponent,
    SearchComponent,
    ThemeComponent, RouterModule, FormsModule, ReactiveFormsModule,
    SvgIconComponent, NgbTooltipModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  loginType: string | null = localStorage.getItem('login_Type');


  downloadDivAsPDF(divId: string) {
    const element = document.getElementById(divId);
    if (!element) return;

    html2canvas(element, {
      scale: 2,
      useCORS: true
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');

      const pdf = new jsPDF('p', 'mm', 'a4');

      const pageWidth = 210;
      const pageHeight = 295;

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`${divId}.pdf`);
    });
  }
  mode: string | null = ''
  modeGrid: string | null = ''
  animateHeader = false;
  sitename: string | null = ''
  profileName: string | null = ''
  public menuItems: Menu[] = [];
  public item: Menu[] = [];
  public searchResult: boolean = false;
  public searchResultEmpty: boolean = false;
  public text: string = '';
  public open = false;
  isOnline = true;
  constructor(public hidenav: HideNavScrollService, public navmenu: NavmenuService, private tourService: TourService, private themeEventSer: ThemeEventService, private connectionService: ConnectionService, private toastService: ToastService, private router: Router, private route: ActivatedRoute, private layout: LayoutService) {

  }
  onDarkModeToggled(isDarkMode: boolean) {
    this.themeEventSer.toggleDarkMode(isDarkMode);
  }
  updateSiteDetails() {

    const url = this.router.url;
    const match = url.match(/\/site_summary\/([^?]+)/);

    const sitename = localStorage.getItem('SiteName');
    const querySiteIdEncoded = this.route.snapshot.queryParamMap.get('siteid');
    const storedSiteIdEncoded = localStorage.getItem('site_idLogin');

    // helper decode
    const decode = (val: string | null) => {
      try {
        return val ? atob(val) : '';
      } catch {
        return '';
      }
    };

    const querySiteId = decode(querySiteIdEncoded);
    const storedSiteId = decode(storedSiteIdEncoded);

    const siteid =
      querySiteId ||
      (storedSiteId && storedSiteId !== 'ALL' ? storedSiteId : '') ||
      '';


    if (match && match[1]) {
      // On /site_summary/:sitename → always update
    } else {

      // Not on site_summary route
      if (!querySiteId && !this.sitename && sitename && sitename !== 'undefined') {
        this.sitename = sitename;
      } else {
        this.sitename = '';
      }

    }
  }
  ReadingUnit: string | null = null;
  replaceValue(value: any, map: any): any {
    if (!value || typeof value !== 'string') return value;

    let result = value;

    // replace DG (case insensitive)
    result = result.replace(/\bDG\b/gi, map['DG'] || 'DG');

    // replace GRID (case insensitive)
    result = result.replace(/\bGRID\b/gi, map['GRID'] || 'GRID');

    return result;
  }
  ngOnInit(): void {

    const textChange = JSON.parse(localStorage.getItem('textchange') || '{}');

    this.layout.message$.subscribe(res => {
      this.mode = this.replaceValue(res, textChange);
    });

    this.layout.messageGrid$.subscribe(res => {
      this.modeGrid = this.replaceValue(res, textChange);
    });
    this.layout.ShowKWH$.subscribe(res => {
      if (res === true) {
        this.ReadingUnit = localStorage.getItem('ReadingUnit')
      }
      else {
        this.ReadingUnit = ''
      }
    })

    this.setOpenByScreenWidth();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateSiteDetails();
      });

    this.updateSiteDetails();
    this.profileName = localStorage.getItem('profile_name');

    if (window.innerWidth <= 991) {
      this.navmenu.closeSidebar = true;
    }

    setTimeout(() => this.animateHeader = true);
    setTimeout(() => this.animateHeader = false, 700);

    this.connectionService.online$.subscribe((status) => {
      this.isOnline = status;
      this.toastService.showToast(
        status ? 'Connected again!' : 'You are offline',
        'colored',
        status ? 2000 : 3000,
        status ? 'success' : 'danger'
      );
    });
  }
  @HostListener('window:resize')
  onResize() {
    this.setOpenByScreenWidth();
  }

  private setOpenByScreenWidth() {
    if (window.innerWidth <= 767) {
      this.open = false
    }
  }





  openMenu() {
    this.navmenu.closeSidebar = !this.navmenu.closeSidebar;
  }


  openSearch() {
    this.open = !this.open
    this.searchResult = false;
  }

  languageToggle() {
    this.navmenu.language = !this.navmenu.language;
  }

  searchTerm(term: any) {
    term ? this.addFix() : this.removeFix();
    if (!term) return this.menuItems = [];
    let items: Menu[] = [];
    term = term.toLowerCase();
    this.item.forEach((data) => {
      if (data.title?.toLowerCase().includes(term) && data.type === 'link') {
        items.push(data);
      }
      data.children?.filter(subItems => {
        if (subItems.title?.toLowerCase().includes(term) && subItems.type === 'link') {
          subItems.icon = data.icon
          items.push(subItems);
        }
        subItems.children?.filter(suSubItems => {
          if (suSubItems.title?.toLowerCase().includes(term)) {
            suSubItems.icon = data.icon
            items.push(suSubItems);
          }
        })
        return
      })
      this.checkSearchResultEmpty(items)
      this.menuItems = items
    })
    return
  }

  checkSearchResultEmpty(items: Menu[]) {
    if (!items.length)
      this.searchResultEmpty = true;
    else
      this.searchResultEmpty = false;
  }

  addFix() {
    this.searchResult = true;
    document.body.classList.add('offcanvas')
  }

  removeFix() {
    this.searchResult = false;
    this.text = "";
    document.body.classList.remove('offcanvas')
  }

  clickOutside(): void {
    this.open = false
    this.searchResult = false;
    this.searchResultEmpty = false;
  }

}
